// document.addEventListener("DOMContentLoaded", function () {
//   // Select DOM elements
//   let mainButton = document.querySelector(".product-form__submit");
//   let buyNowButtons = document.querySelector(".shopify-payment-button__button");
//   let dummyButtonATC = document.querySelector(".dummy-atc-button");

//   let mainQauntity = document.querySelector(".product__buy-buttons-container .quantity");
//   let mainMinus = mainQauntity.querySelector('[name="minus"]');
//   let mainPlus = mainQauntity.querySelector('[name="plus"]');

//   let barQuantity = document.querySelector('[data-id="barQuantity"]');
//   let barInput = barQuantity.querySelector("input");
//   let barMinus = barQuantity.querySelector('[name="minus"]');
//   let barPlus = barQuantity.querySelector('[name="plus"]');

//   const refToRedirect = document.querySelector(".product-form__error-message-wrapper");

//   // Function to toggle loader on buttons
//   function toggleLoader(button, showLoader) {
//     const buttonContent = button.querySelector(".custom-atc-btn");
//     const spinner = button.querySelector(".loading__spinner");

//     button.disabled = showLoader;
//     if (buttonContent) buttonContent.style.display = showLoader ? "none" : "block";
//     if (spinner) spinner.classList.toggle("hidden", !showLoader);
//   }

//   // Sync dummy ATC button with Main ATC button (It also handles loader, redirect and quantity sync)
//   dummyButtonATC.addEventListener("click", () => {
//     try {
//       toggleLoader(dummyButtonATC, true);

//       setTimeout(() => {
//         mainButton.click();
//         toggleLoader(dummyButtonATC, false);

//         if (refToRedirect) {
//           const observer = new MutationObserver((mutations) => {
//             mutations.forEach((mutation) => {
//               if (!refToRedirect.hasAttribute("hidden")) {
//                 refToRedirect.scrollIntoView({ behavior: "smooth", block: "center" });
//                 observer.disconnect();
//               }
//             });
//           });

//           observer.observe(refToRedirect, { attributes: true, attributeFilter: ["hidden"] });
//         }
//       }, 3000);
//     } catch (error) {
//       console.error("Error in Add to Cart process:", error);
//       toggleLoader(dummyButtonATC, false);
//     }
//   });

//   // Sync dummy Quantity Button with Main Quantity Button
//   if (barMinus) {
//     barMinus.addEventListener("click", () => {
//       barInput.stepDown();
//       mainMinus.click();
//     });
//   }
//   if (barPlus) {
//     barPlus.addEventListener("click", () => {
//       barInput.stepUp();
//       mainPlus.click();
//     });
//   }
// });

// // Function to change variant details on variant change PDP (Only from Metafields Data)
// function changeVariant(e) {
//   const variantMetaValuePack = e.getAttribute("selected-variant-meta-pack");
//   const variantMetaValueGram = e.getAttribute("selected-variant-meta-gram");
//   if (variantMetaValuePack) {
//     document.querySelector(".info-pack-size strong").nextSibling.nodeValue = `${variantMetaValuePack}`;
//   }
//   if (variantMetaValueGram) {
//     document.querySelector(".sticky-bar-container .gram-info p").innerHTML = `${variantMetaValueGram}`;
//   }
// }


document.addEventListener("DOMContentLoaded", function () {
  // Select DOM elements
  const mainButton = document.querySelector(".product-form__submit");
  const dummyButtonATC = document.querySelector(".dummy-atc-button");
  const mainQuantity = document.querySelector(".product__buy-buttons-container .quantity");
  const mainMinus = mainQuantity ? mainQuantity.querySelector('[name="minus"]') : null;
  const mainPlus = mainQuantity ? mainQuantity.querySelector('[name="plus"]') : null;
  const barQuantity = document.querySelector('[data-id="barQuantity"]');
  const barInput = barQuantity ? barQuantity.querySelector("input") : null;
  const barMinus = barQuantity ? barQuantity.querySelector('[name="minus"]') : null;
  const barPlus = barQuantity ? barQuantity.querySelector('[name="plus"]') : null;
  const refToRedirect = document.querySelector(".product-form__error-message-wrapper");

  // Function to toggle loader on buttons
  function toggleLoader(button, showLoader) {
    if (!button) return;
    const buttonContent = button.querySelector(".custom-atc-btn");
    const spinner = button.querySelector(".loading__spinner");
    button.disabled = showLoader;
    if (buttonContent) buttonContent.style.display = showLoader ? "none" : "block";
    if (spinner) spinner.classList.toggle("hidden", !showLoader);
  }

  // Sync dummy ATC button with Main ATC button
  if (dummyButtonATC && mainButton) {
    dummyButtonATC.addEventListener("click", () => {
      try {
        toggleLoader(dummyButtonATC, true);
        setTimeout(() => {
          mainButton.click();
          toggleLoader(dummyButtonATC, false);
          if (refToRedirect) {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (!refToRedirect.hasAttribute("hidden")) {
                  refToRedirect.scrollIntoView({ behavior: "smooth", block: "center" });
                  observer.disconnect();
                }
              });
            });
            observer.observe(refToRedirect, { attributes: true, attributeFilter: ["hidden"] });
          }
        }, 3000);
      } catch (error) {
        console.error("Error in Add to Cart process:", error);
        toggleLoader(dummyButtonATC, false);
      }
    });
  }

  // Sync dummy Quantity Button with Main Quantity Button
  if (barMinus && mainMinus && barInput) {
    barMinus.addEventListener("click", () => {
      barInput.stepDown();
      mainMinus.click();
    });
  }

  if (barPlus && mainPlus && barInput) {
    barPlus.addEventListener("click", () => {
      barInput.stepUp();
      mainPlus.click();
    });
  }
});

// Function to change variant details on variant change PDP (Only from Metafields Data)
function changeVariant(e) {
  const variantMetaValuePack = e.getAttribute("selected-variant-meta-pack");
  const variantMetaValueGram = e.getAttribute("selected-variant-meta-gram");

  if (variantMetaValuePack) {
    const packEl = document.querySelector(".info-pack-size strong");
    if (packEl && packEl.nextSibling) {
      packEl.nextSibling.nodeValue = variantMetaValuePack;
    }
  }

  if (variantMetaValueGram) {
    const gramEl = document.querySelector(".sticky-bar-container .gram-info p");
    if (gramEl) {
      gramEl.innerHTML = variantMetaValueGram;
    }
  }
}